export const DEFAULT_CAR_FORM = {
  type: 'car',
  head: {
    mandante: { value: '', isPublic: true },
    categoria: { value: '', isPublic: true },
    tipo: { value: '', isPublic: true },
    marca: { value: '', isPublic: true },
    modelo: { value: '', isPublic: true },
    version: { value: '', isPublic: true },
    ano: { value: '', isPublic: true },
    color: { value: '', isPublic: true },
    patente: { value: '', isPublic: true },
    motor: { value: '', isPublic: true },
    chasis: { value: '', isPublic: true },
    kms: { value: '', isPublic: true },
    horas: { value: '', isPublic: true },
    codigo: { value: '', isPublic: true },
    permiso: { value: { checked: false, obs: '' }, isPublic: true },
    revision: { value: { checked: false, obs: '' }, isPublic: true },
    certificacion: { value: { checked: false, obs: '' }, isPublic: true },
    seguro: { value: { checked: false, obs: '' }, isPublic: true },
  },
  bodyinspection: {},
  accesoriesInventory: {
    ac: { isPublic: true },
    carplayAndroidAuto: { isPublic: true },
    keyless: { isPublic: true },
  },
  mecanicState: {
    motor: { isPublic: true },
    cilindrada: { isPublic: true },
    transmisionDiferencial: { isPublic: true },
    tipoTransmision: { isPublic: true },
    rodadosNeumaticos: { isPublic: true },
    sistemaElectrico: { isPublic: true },
    sistemaHidraulico: { isPublic: true },
    otros: { isPublic: true },
    funciona: { isPublic: true },
    tipoCombustible: { isPublic: true },
    adblue: { isPublic: true },
    traccion: { isPublic: true },
  },
  safetyness: {},
  comments: '',
};

export const DEFAULT_TRUCK_FORM = {
  type: 'truck',
  head: {
    mandante: { value: '', isPublic: true },
    categoria: { value: '', isPublic: true },
    tipo: { value: '', isPublic: true },
    marca: { value: '', isPublic: true },
    modelo: { value: '', isPublic: true },
    ano: { value: '', isPublic: true },
    color: { value: '', isPublic: true },
    patente: { value: '', isPublic: true },
    motor: { value: '', isPublic: true },
    chasis: { value: '', isPublic: true },
    kms: { value: '', isPublic: true },
    horas: { value: '', isPublic: true },
    codigo: { value: '', isPublic: true },
    permiso: { value: { checked: false, obs: '' }, isPublic: true },
    revision: { value: { checked: false, obs: '' }, isPublic: true },
    certificacion: { value: { checked: false, obs: '' }, isPublic: true },
    seguro: { value: { checked: false, obs: '' }, isPublic: true },
  },
  bodyinspection: {},
  accesoriesInventory: {
    ac: { isPublic: true },
  },
  mecanicState: {
    motor: { isPublic: true },
    cilindrada: { isPublic: true },
    transmisionDiferencial: { isPublic: true },
    tipoTransmision: { isPublic: true },
    rodadosNeumaticos: { isPublic: true },
    sistemaElectrico: { isPublic: true },
    sistemaHidraulico: { isPublic: true },
    funciona: { isPublic: true },
    tipoCombustible: { isPublic: true },
    adblue: { isPublic: true },
    traccion: { isPublic: true },
    otros: { isPublic: true },
  },
  safetyness: {},
  comments: '',
};

export const DEFAULT_MACHINERY_FORM = {
  type: 'machinery',
  head: {
    mandante: { value: '', isPublic: true },
    categoria: { value: '', isPublic: true },
    tipo: { value: '', isPublic: true },
    marca: { value: '', isPublic: true },
    modelo: { value: '', isPublic: true },
    ano: { value: '', isPublic: true },
    color: { value: '', isPublic: true },
    patente: { value: '', isPublic: true },
    motor: { value: '', isPublic: true },
    chasis: { value: '', isPublic: true },
    kms: { value: '', isPublic: true },
    horas: { value: '', isPublic: true },
    codigo: { value: '', isPublic: true },
    permiso: { value: { checked: false, obs: '' }, isPublic: true },
    revision: { value: { checked: false, obs: '' }, isPublic: true },
    certificacion: { value: { checked: false, obs: '' }, isPublic: true },
    seguro: { value: { checked: false, obs: '' }, isPublic: true },
  },
  bodyinspection: {},
  accesoriesInventory: {
    ac: { isPublic: true },
  },
  mecanicState: {
    brazos: { isPublic: true },
    cajaCambios: { isPublic: true },
    carroceria: { isPublic: true },
    cilindrada: { isPublic: true },
    combustible: { isPublic: true },
    funciona: { isPublic: true },
    motor: { isPublic: true },
    neumaticos: { isPublic: true },
    sistemaElectrico: { isPublic: true },
    sistemaHidraulico: { isPublic: true },
    tipoCombustible: { isPublic: true },
    tipoTransmision: { isPublic: true },
    transmision: { isPublic: true },
    traccion: { isPublic: true },
    otros: { isPublic: true },
  },
  safetyness: {},
  comments: '',
};

export const DEFAULT_MANY = {
  type: 'many',
  head: {
    mandante: { value: '', isPublic: true },
    categoria: { value: '', isPublic: true },
    tipo: { value: '', isPublic: true },
    marca: { value: '', isPublic: true },
    modelo: { value: '', isPublic: true },
    ano: { value: '', isPublic: true },
    color: { value: '', isPublic: true },
    patente: { value: '', isPublic: true },
    motor: { value: '', isPublic: true },
    chasis: { value: '', isPublic: true },
    kms: { value: '', isPublic: true },
    horas: { value: '', isPublic: true },
    codigo: { value: '', isPublic: true },
    permiso: { value: { checked: false, obs: '' }, isPublic: true },
    revision: { value: { checked: false, obs: '' }, isPublic: true },
    certificacion: { value: { checked: false, obs: '' }, isPublic: true },
    seguro: { value: { checked: false, obs: '' }, isPublic: true },
  },
  comments: '',
};
